import { useCallback, useMemo } from 'react';
import type { Course } from 'src/types';
import { IS_LOCALHOST } from 'src/config-global';

import { useActivePlatform } from './use-active-platform';

export const useCourseAccess = () => {
  const { platform, isLoading } = useActivePlatform();

  const courseAccess = platform?.course_access;
  const hasFullAccess = !courseAccess || courseAccess.all_courses;

  const allowedCourseIds = useMemo(
    () => (hasFullAccess ? [] : courseAccess?.course_ids),
    [hasFullAccess, courseAccess]
  );

  const canAccessCourse = useCallback(
    (courseId: Course['id'] | undefined | null): boolean => {
      if (IS_LOCALHOST) return true;
      if (hasFullAccess) return true;
      if (!courseId) return true;
      return !!allowedCourseIds?.includes(courseId);
    },
    [hasFullAccess, allowedCourseIds]
  );

  return {
    hasFullAccess,
    allowedCourseIds,
    canAccessCourse,
    isLoading,
  };
};
